"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoBox = exports.makeMyClasses = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const useAltForSelfLang_1 = __importDefault(require("@opsbase/react-ctrl-self/helpers/useAltForSelfLang"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const react_simple_quill_1 = __importDefault(require("@opsbase/react-simple-quill"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Link_1 = __importDefault(require("@opsbase/web-nav/Link/Link"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav/useNav"));
const react_1 = __importStar(require("react"));
require("react-quill/dist/quill.snow.css");
const makeMyClasses = () => ({
    root: {
        overflow: 'auto',
        borderRadius: 4,
        width: '100%',
        backgroundColor: lib_palette_1.default.WhiteSmoke.main,
        '& p': {
            margin: 0,
        },
        '& .ql-container.ql-snow': {
            border: '0 !important',
        },
    },
});
exports.makeMyClasses = makeMyClasses;
const InfoBox = (props) => {
    const { rule } = (0, usePerformQuestion_1.default)();
    const [richInfo] = (0, useAltForSelfLang_1.default)(rule.richInfo, rule.richInfoAlt);
    const { html, files, fileUrls } = richInfo;
    const { openUrl } = (0, useNav_1.default)();
    const myCss = (0, web_css_1.default)(exports.makeMyClasses);
    const handleClick = (0, useCallforward_1.default)(url => () => {
        openUrl(url);
    }, [openUrl]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Pane_1.default, Object.assign({}, props, { classes: { root: myCss.root } }),
            !!(html === null || html === void 0 ? void 0 : html.length) && (react_1.default.createElement(react_simple_quill_1.default, { readOnly: true, value: html, modules: { toolbar: false } })), fileUrls === null || fileUrls === void 0 ? void 0 :
            fileUrls.map((u, i) => (react_1.default.createElement(Link_1.default, { onClick: handleClick(u) }, files === null || files === void 0 ? void 0 : files[i])))))), [fileUrls, files, handleClick, html, myCss.root, props]);
};
exports.InfoBox = InfoBox;
exports.default = exports.InfoBox;
